import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import { ConfiguredAgenda } from "./type";
import ScrollIndicatorWrapper from "../../../../../atoms/scroll-indicator-wrapper";

const AgendaPreview = ({ agenda }: { agenda?: ConfiguredAgenda }) => {
  if (!agenda) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          color: "text.secondary",
          textAlign: "center",
          p: 2
        }}
      >
        <Typography variant="body2">
          Click on an agenda from the list to preview its questions
        </Typography>
      </Box>
    );
  }

  const responses = Array.isArray(agenda.agenda_responses)
    ? agenda.agenda_responses
    : [];

  return (
    <ScrollIndicatorWrapper
      contentKey={agenda.id}
      sx={{
        overflow: "auto",
        flex: 1,
        p: 2,
      }}
    >
      <Typography fontSize={16} fontWeight={500} sx={{ mb: 1.5, color: "primary.main" }}>
        {agenda.title}
      </Typography>

      {responses.length === 0 ? (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          No questions available for this agenda.
        </Typography>
      ) : (
        <List disablePadding>
          {responses.map((item, index) => (
            <Box key={item.question}>
              <ListItem alignItems="flex-start" disablePadding sx={{ mb: 2 }}>
                <ListItemText
                  primary={
                    <Stack direction={'row'} justifyContent={'space-between'}>
                      <Stack direction="row" justifyContent="flex-start" gap={2} alignItems="flex-start">
                        <Typography fontWeight={500} fontSize={'13px'} sx={{ opacity: "0.85" }}>
                          <strong>Q{index + 1}:</strong>
                        </Typography>
                        <Typography
                          style={{ whiteSpace: "pre-wrap" }} 
                          fontWeight={500}
                          fontSize={'14px'}
                          sx={{ opacity: "0.85" }}
                        >
                          {item.question}
                        </Typography>
                      </Stack>
                      <Chip
                        variant="outlined"
                        label={item.isNewQuestion ? "New" : "Shared"}
                        color={item.isNewQuestion ? "success" : "info"}
                        size="small"
                      />
                    </Stack>
                  }
                  secondary={
                    <>
                      {item.answer && (
                        <Stack direction="row" spacing={1.5}>
                          <Typography
                            fontWeight={600}
                            fontSize={'12px'}
                            sx={{ opacity: "0.75", mt: 1 }}
                          >
                            <strong>Answer:</strong>
                          </Typography>
                          <Typography
                            style={{ whiteSpace: "pre-line" }}
                            fontWeight={600}
                            fontSize={'12px'}
                            sx={{ color: "#099A51", opacity: "0.75", mt: 1 }}
                          >
                            {item.answer}
                          </Typography>
                        </Stack>
                      )}
                      {item.expert_note && (
                        <Stack direction="row" spacing={1.5}>
                          <Typography
                            fontWeight={600}
                            fontSize={'12px'}
                            sx={{ opacity: "0.75", mt: 1 }}
                          >
                            <strong>Expert Note:</strong>
                          </Typography>
                          <Typography
                            style={{ whiteSpace: "pre-line" }}
                            fontWeight={600}
                            fontSize={'12px'}
                            sx={{ opacity: "0.75", mt: 1 }}
                          >
                            {item.expert_note}
                          </Typography>
                        </Stack>
                      )}
                    </>
                  }
                />
              </ListItem>
              {index < responses.length - 1 && <Divider sx={{ my: 2 }} />}
            </Box>
          ))}
        </List>
      )}
    </ScrollIndicatorWrapper>
  );
};

export default AgendaPreview;
